import MSpecialBusinessDaySettingItem from './index.vue';

MSpecialBusinessDaySettingItem.install = app => {
  app.component(MSpecialBusinessDaySettingItem.name, MSpecialBusinessDaySettingItem);
};

export default MSpecialBusinessDaySettingItem;
